function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*
 *  Quantity Selector
 *
 *  Version
 *    1.0.0 - 2020/03/04
 */

export var WRAPPER = '[data-quantity-selector]';
export var FIELD = '[data-quantity-selector-field]';
export var MINUS_BUTTON = '[data-quantity-selector-minus]';
export var PLUS_BUTTON = '[data-quantity-selector-plus]';
import { ON_CART_PENDING, ON_CART_FINISHED, generateIcon } from '@process-creative/slate-theme-tools';
export var ACTIVE_SELECTORS = [];
export var QuantitySelector = /*#__PURE__*/function () {
  function QuantitySelector(container) {
    _classCallCheck(this, QuantitySelector);
    this.container = container;
    this.wrapper = container.find(WRAPPER);
    if (!this.wrapper.length) this.wrapper = this.container;

    //Elements
    this.minus = this.container.find(MINUS_BUTTON);
    this.input = this.container.find(FIELD);
    this.plus = this.container.find(PLUS_BUTTON);

    //Values
    this.min = this.wrapper.attr('data-min') || 0;
    this.max = this.wrapper.attr('data-max') || null;
    this.value = this.getSelectorValue();
    if (this.min == "null") this.min = null;
    if (this.max == "null") this.max = null;

    //Events
    this.attachEvents();
  }
  _createClass(QuantitySelector, [{
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      this.minusHandler = function (e) {
        return _this.onMinusClick(e);
      };
      this.plusHandler = function (e) {
        return _this.onPlusClick(e);
      };
      this.changeHandler = function (e) {
        return _this.onFieldChange(e);
      };
      this.cartPendingHandler = function () {
        return _this.onCartPending();
      };
      this.cartFinishedHandler = function () {
        return _this.onCartFinished();
      };
      this.container.on('click', MINUS_BUTTON, this.minusHandler);
      this.container.on('click', PLUS_BUTTON, this.plusHandler);
      this.container.on('change', FIELD, this.changeHandler);
      $(document).on(ON_CART_PENDING, this.cartPendingHandler);
      $(document).on(ON_CART_FINISHED, this.cartFinishedHandler);
      if (ACTIVE_SELECTORS.indexOf(this) === -1) ACTIVE_SELECTORS.push(this);
    }
  }, {
    key: "detachEvents",
    value: function detachEvents() {
      this.container.off('click', MINUS_BUTTON, this.minusHandler);
      this.container.off('click', PLUS_BUTTON, this.plusHandler);
      this.container.off('change', FIELD, this.changeHandler);
      $(document).off(ON_CART_PENDING, this.cartPendingHandler);
      $(document).off(ON_CART_FINISHED, this.cartFinishedHandler);
      var i = ACTIVE_SELECTORS.indexOf(this);
      if (i !== -1) ACTIVE_SELECTORS.splice(i, 1);
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.value;
    }
  }, {
    key: "getSelectorValue",
    value: function getSelectorValue() {
      var val = parseInt(this.input.val());
      if (isNaN(val) || !isFinite(val)) val = 1;
      return val;
    }
  }, {
    key: "setMin",
    value: function setMin(min) {
      this.min = min;
      this.setValue(this.getValue());
    }
  }, {
    key: "setMax",
    value: function setMax(max) {
      this.max = max;
      this.setValue(this.getValue());
    }
  }, {
    key: "setValue",
    value: function setValue(value, fireEvent) {
      if (_typeof(fireEvent) === (typeof undefined === "undefined" ? "undefined" : _typeof(undefined))) fireEvent = true;
      //String checking
      value = "".concat(value);
      if (!value.replace(/\s/gi).length) value = this.getValue();
      if (!value.replace(/\s/gi).length) value = 1;
      value = parseInt(value);
      if (isNaN(value) || !isFinite(value)) value = 1;

      //Clamping
      if (this.max != null && value > this.max) value = this.max;
      if (this.min != null && value < this.min) value = this.min;

      //No need to update if current
      var current = this.getValue();
      this.value = value;

      //Due to an issue with jQuery we have to wait a frame before we can update
      //the input field to reflect the changes.
      if (this.getSelectorValue() != value) this.input.val("".concat(value));
      this.updateClasses();
      if (fireEvent && current != value) this.onQuantityChanged(value, current);
    }

    //Rendering
  }, {
    key: "updateClasses",
    value: function updateClasses() {
      if (this.max != null && this.min != null && this.min >= this.max) {
        this.input.addClass('is-disabled');
        this.input.attr('disabled', 'disabled');
      } else {
        this.input.removeClass('is-disabled');
        this.input.removeAttr('disabled');
      }

      //Update Minus Button
      if (this.min != null && this.getValue() <= this.min) {
        this.minus.addClass('is-disabled');
        this.minus.attr('disabled', 'disabled');
      } else {
        this.minus.removeClass('is-disabled');
        this.minus.removeAttr('disabled');
      }

      //Update Plus Button
      if (this.max != null && this.getValue() >= this.max) {
        this.plus.addClass('is-disabled');
        this.plus.attr('disabled', 'disabled');
      } else {
        this.plus.removeClass('is-disabled');
        this.plus.removeAttr('disabled');
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.detachEvents();
    }

    //Events
  }, {
    key: "onQuantityChanged",
    value: function onQuantityChanged(newQuantity, oldQuantity) {}
  }, {
    key: "onQuantityPlus",
    value: function onQuantityPlus() {}
  }, {
    key: "onQuantiyMinus",
    value: function onQuantiyMinus() {}
  }, {
    key: "onFieldChange",
    value: function onFieldChange(e) {
      var _this2 = this;
      setTimeout(function () {
        //We have to use current target to avoid the jQuery cutoff
        _this2.setValue(_this2.input.val());
      }, 0);
    }
  }, {
    key: "onMinusClick",
    value: function onMinusClick(e) {
      e.preventDefault();
      e.stopPropagation();
      this.setValue(this.getValue() - 1);
      this.onQuantiyMinus();
    }
  }, {
    key: "onPlusClick",
    value: function onPlusClick(e) {
      e.preventDefault();
      e.stopPropagation();
      this.setValue(this.getValue() + 1);
      this.onQuantityPlus();
    }
  }, {
    key: "onCartPending",
    value: function onCartPending() {
      this.plus.addClass('is-disabled');
      this.plus.attr('disabled', 'disabled');
      this.minus.addClass('is-disabled');
      this.minus.attr('disabled', 'disabled');
      this.input.addClass('is-disabled');
      this.input.attr('disabled', 'disabled');
    }
  }, {
    key: "onCartFinished",
    value: function onCartFinished() {
      this.updateClasses();
    }
  }]);
  return QuantitySelector;
}();
export var generateQuantitySelector = function generateQuantitySelector(options) {
  options = options || {};
  var _options = options,
    clazz = _options.clazz,
    name = _options.name,
    quantity = _options.quantity,
    min = _options.min,
    max = _options.max,
    isSmall = _options.isSmall,
    styleMinus = _options.styleMinus,
    stylePlus = _options.stylePlus;
  clazz = clazz || "";
  name = name || "quantity";
  if (_typeof(quantity) === (typeof undefined === "undefined" ? "undefined" : _typeof(undefined))) quantity = 1;
  if (_typeof(min) === (typeof undefined === "undefined" ? "undefined" : _typeof(undefined))) min = null;
  if (_typeof(max) === (typeof undefined === "undefined" ? "undefined" : _typeof(undefined))) max = null;
  if (_typeof(isSmall) === (typeof undefined === "undefined" ? "undefined" : _typeof(undefined))) isSmall = false;
  var minusDisabled = false;
  var plusDisabled = false;
  var inputDisabled = false;
  if (min != null && quantity <= min) minusDisabled = true;
  if (max != null && quantity >= max) plusDisabled = true;
  if (max != null && min >= max) inputDisabled = true;
  return "\n    <div class=\"o-quantity-selector ".concat(clazz, " ").concat(isSmall ? 'is-small' : '', "\">\n      <div class=\"o-quantity-selector__inner\">\n        <button\n          type=\"button\" class=\"\n            o-btn is-square o-quantity-selector__button is-minus\n            ").concat(isSmall ? '' : 'is-large', "\n            ").concat(minusDisabled ? 'is-disabled' : '', "\n          \" ").concat(minusDisabled ? 'disabled' : '', " data-quantity-selector-minus\n        >\n          ").concat(generateIcon('minus', 'o-btn__icon'), "\n        </button>\n\n        ").concat(isSmall ? "\n          <input\n            type=\"hidden\" value=".concat(quantity, "\" data-quantity-selector-field name=\"").concat(name, "\"\n          />\n        ") : "\n          <div class=\"o-quantity-selector__input\">\n            <input\n              type=\"text\" class=\"o-quantity-selector__input-field ".concat(inputDisabled ? 'disabled' : '', "\"\n              ").concat(inputDisabled ? 'disabled' : '', " value=\"").concat(quantity, "\" name=\"").concat(name, "\" data-quantity-selector-field\n            />\n          </div>\n        "), "\n\n        <button\n          type=\"button\" class=\"\n            o-btn   is-square o-quantity-selector__button is-plus\n            ").concat(isSmall ? '' : 'is-large', "\n            ").concat(plusDisabled ? 'is-disabled' : '', "\n          \" ").concat(plusDisabled ? 'disabled' : '', " data-quantity-selector-plus\n        >\n          ").concat(generateIcon('plus', 'o-btn__icon'), "\n        </button>\n      </div>\n    </div>\n  ");
};